import { gsap, ScrollTrigger } from '@gsap';
import Swiper from "swiper/bundle";
import "swiper/css/bundle";
/**
 * Layout: Program
 * Slug: program
 */

document.addEventListener('DOMContentLoaded', function() {
	gsap.registerPlugin(ScrollTrigger);
    const layouts = document.querySelectorAll('.flex-layout.program-layout');

	layouts.forEach((layout) => {
		const progress = layout.querySelector(".swiper-progress-bar");
		const prevEl = layout.querySelector(".swiper-nav-prev");
		const nextEl = layout.querySelector(".swiper-nav-next");

		return new Swiper(layout.querySelector(".swiper-container"), {
			spaceBetween: 16,
			slidesPerView: 1.5,
			navigation: {
				prevEl: prevEl,
				nextEl: nextEl,
			},
			on: {
				slideChange: (self) => {
					const fraction = gsap.utils.clamp(
						5,
						100,
						self.progress * 100,
					);

					if (progress) {
						gsap.to(progress, {
							width: fraction + "%",
						});
					}
				},
				afterInit: (self) => {
					gsap.from(self.slides, {
						y: -20,
						autoAlpha: 0,
						duration: 0.2,
						stagger: 0.1,
						scrollTrigger: {
							trigger: self.el,
							start: "top center+=25%",
							markers: false
						}
					});
				}
			},
			breakpoints: {
				768: {
					slidesPerView: 3
				},
				993: {
					slidesPerView: 4
				},
				1280: {
					slidesPerView: 6
				}
			}
		});
	});
});
